// extracted by mini-css-extract-plugin
export default {"layout":"e91e56af4b d7e78d1be6 _27c17a1f15","h_slide":"_50d648699c","category":"_77933fb257 e3d439cc26 ba4939f01e"};